import { useReadFilesAsBase64 } from 'components/FilesSelector/hooks/useReadFilesAsBase64';
import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { ContractImportEnum } from 'gql/graphql';
import { ExportCSVReport } from 'utils/createCSVReportFile';

import { useState, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { createContractGql } from '../ContractQueries';

export const useUploadContract = (
    projectId: string | undefined,
    selectedItem: ContractImportEnum,
    catalogUERBaseUniqueId: string | undefined,
) => {
    const dispatch = useDispatch();
    const [files, setFiles] = useState<File[]>([]);

    const [makeUploadContractReset] = useResetStoreData({ requestId: 'uploadContract' });
    const base64Files = useReadFilesAsBase64(files);

    const [isSubmitted, setIsSubmitted] = useState(false);

    const [uploadContractData, uploadContractStatus, uploadContractError, uploadContractMakeRequest] = useRequest({
        requestId: 'uploadContract',
        query: createContractGql,
        withEffect: false,
    });

    useEffect(
        () => () => {
            makeUploadContractReset(undefined);
        },
        [dispatch, makeUploadContractReset],
    );

    useEffect(() => {
        if (
            base64Files?.length &&
            !uploadContractData?.uerCreateContract?.data?.id &&
            projectId &&
            catalogUERBaseUniqueId
        ) {
            dispatch(
                uploadContractMakeRequest({
                    projectUniqueId: projectId,
                    fileContent: base64Files[0],
                    importOption: selectedItem,
                    catalogUERBaseUniqueId,
                }),
            );

            setIsSubmitted(true);
        }
    }, [
        base64Files,
        catalogUERBaseUniqueId,
        dispatch,
        projectId,
        selectedItem,
        uploadContractData?.uerCreateContract?.data?.id,
        uploadContractMakeRequest,
    ]);

    const makeRequestHandler = useCallback(
        (filesToUpload) => {
            if (filesToUpload.length && projectId) {
                setFiles(filesToUpload);
            }
        },
        [projectId],
    );

    const handleCloseModalError = useCallback(() => {
        setIsSubmitted(false);
        setFiles([]);
    }, []);

    const handleCreateReport = () => {
        ExportCSVReport(uploadContractData?.uerCreateContract?.validation);
    };

    return {
        isSubmitted,
        uploadContractData,
        uploadContractStatus,
        uploadContractError,
        makeRequestHandler,
        handleCloseModalError,
        handleCreateReport,
        makeUploadContractReset,
    };
};
